export const SAVE_AND_CONTINUE_CREATE = "shouldContinueCreate";
export const SAVE_AND_CONTINUE_EDIT = "shouldContinueEdit";